import type { ScratchcardBundle, ScratchcardPayTable } from '../types';

function getScratchcardUnitPrice(bundles: ScratchcardBundle[]): number {
  const unitBundle = bundles.find(bundle => bundle.quantity === 1);
  if (unitBundle) {
    return unitBundle.price;
  }

  const firstBundle = bundles[0];
  if (!firstBundle || firstBundle.quantity <= 0) {
    return 0;
  }

  return firstBundle.price / firstBundle.quantity;
}

function getScratchcardMaxPrize(payTables: ScratchcardPayTable[]): number {
  if (payTables.length === 0) {
    return 0;
  }

  return Math.max(...payTables.map(row => row.amount));
}

export { getScratchcardMaxPrize, getScratchcardUnitPrice };
